import React, { useState } from "react";
import { connect } from "react-redux";

import moment from "moment";
import "moment/locale/es-us";
import EntitiesTreeView from "./Tables/EntitiesTreeView";
import DateTimePicker from "./Picker/DateTimePicker";
import "../../scss/react-checkbox-tree.css";

import { userEntitiesSave, userDateSave } from "../../redux/actions/actions";

const ConfigurationPane = (props) => {
  const [time, setTime] = useState({
    dateStart: moment(new Date()),
    dateEnd: moment(new Date()),
    timeStart: null,
    timeEnd: null,
  });
  const [selectedEntities, setSelectedEntities] = useState([]);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleTimeChange = (event) => {
    const time_ = time;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    time_[name] = value;
    setTime(time_);
  };

  const handleDateStart = (dateStart) => {
    if (dateStart) {
      const time_ = time;
      time_.dateStart = dateStart;
      setTime(time_);
    }
  };

  const handleDateEnd = (dateEnd) => {
    if (dateEnd) {
      const time_ = time;
      time_.dateEnd = dateEnd;
      setTime(time_);
    }
  };

  const onEntitiesTreeChange = (checked) => {
    setSelectedEntities(checked)
  };

  const onShowAlert = () => {
    setSuccess(true);
    window.setTimeout(() => {
      setSuccess(false);
    }, 5000);
  };

  // Guarda las entidades y los días en el store de redux
  // Todo: Ver si se ejecuta demasio (puede necesitar un useEffect) 
  const onApply = () => {
    const { userEntitiesSave, userDateSave } = props;
    const date = time;
    userEntitiesSave(selectedEntities);
    userDateSave(date);

    const layout = document.getElementsByClassName("header-fixed")[0];
    if (layout) {
      layout.classList.remove("aside-menu-show");
      layout.classList.remove("aside-menu-lg-show");
    }
  };

  return (
    <div id="panel" role='panel'>
      <DateTimePicker
        time={time}
        handleTimeChange={(event) => handleTimeChange(event)}
        handleDateStart={(dateStart) => handleDateStart(dateStart)}
        handleDateEnd={(dateEnd) => handleDateEnd(dateEnd)}
      />
      <EntitiesTreeView
        onChange={(checked) => onEntitiesTreeChange(checked)}
        onApply={() => onApply}
        success={success}
        error={error}
      />
    </div>
  );
}

const mapStateToProps = ({ user: { userinfo } }) => userinfo;

export default connect(mapStateToProps, { userEntitiesSave, userDateSave })(
  ConfigurationPane
);
